import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const ProtectedRoute = ({ children }) => {
  const { state } = useApp();
  const { isAuthenticated } = state;

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
